import { useEffect, useState, useCallback } from "react";
import { useQueries } from "@tanstack/react-query";
import { toast } from "sonner";

// fetch
import { getMultiMeiliTaskStatus } from "data/fetch";

// types
import { MultiMeiliTaskStatus } from "types/extended-profile.types";

export function useMultiMeiliTaskToast() {

	const [groups, setGroups] = useState<MultiMeiliTaskStatus[]>([]);

	const addTasks = useCallback((group: MultiMeiliTaskStatus) => {
		if (!group || !group?.id) {
			setGroups(prev => prev.filter(t => t.id));
			toast.success(
				<div>
					{group?.label} changes are processing and will be reflected in search within the <strong>next business day</strong>
				</div>,
				{ duration: Infinity }
			);
			return
		}
		setGroups((prev) => [...prev, group]);
	}, []);

	const queries = useQueries({
		queries: groups.map((group) => ({
			queryKey: ["multiMeiliTaskStatus", group?.id],
			queryFn: () => getMultiMeiliTaskStatus(group),
			enabled: !!group?.id,
		})),
	});

	const queryData = queries.map(task => task.data)

	useEffect(() => {
		if (queryData?.length > 0) {
			queryData.forEach((task) => {
				if (!task) return; // skip until data is loaded
				if (task.statuses) {
					const allSucceeded = task.statuses.every((status) => status.status === 'succeeded');
					if (allSucceeded) {
						setGroups((prev) => prev.filter(t => t.id !== task.id));
					toast.success(`${task?.label} updated successfully`, { description: "Your profile updates are now reflected in search results", duration: Infinity });
					} else {
						setGroups((prev) => prev.filter(t => t.id !== task.id));
						toast.success(
							<div>
								{task?.label} changes are processing and will be reflected in search within the <strong>next business day</strong>
							</div>,
							{ duration: Infinity }
						);
					}
				}
			});
		}
	}, [queryData]);

	return addTasks
}